"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppsMenu = AppsMenu;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function AppsMenu(_ref) {
  var access = _ref.access,
    apps = _ref.apps,
    anchorRef = _ref.anchorRef,
    onClose = _ref.onClose;
  var theme = (0, _material.useTheme)();
  var getUrl = function getUrl(app) {
    var _a;
    var prefix = (access === null || access === void 0 ? void 0 : access.tenant) ? "/t/".concat((_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id) : '';
    var url;
    switch (app.id) {
      case 'admin':
        url = process.env.REACT_APP_ADMIN_URL;
        break;
      case 'cdg':
        url = process.env.REACT_APP_CDG_URL;
        break;
      case 'budgets':
        url = process.env.REACT_APP_BUDGETS_URL;
        break;
      case 'requisitions':
        url = process.env.REACT_APP_REQUISITIONS_URL;
        break;
      default:
        url = '#';
    }
    return "".concat(url).concat(prefix);
  };
  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.preventDefault();
      onClose();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.PopperMenu, {
    placement: "bottom-end",
    anchorRef: anchorRef,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuList, {
    autoFocusItem: true,
    id: "apps-menu",
    onKeyDown: handleListKeyDown
  }, apps.map(function (app) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: app.id,
      component: "a",
      onClick: onClose,
      href: getUrl(app),
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.CustomAvatar, {
      name: app.name,
      logo: app.logo,
      color: theme.palette.secondary.main
    })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "inherit"
    }, app.name));
  })));
}